<crm-status-label
  *ngFor="let status of selectedTasksPossibleStatuses | async | orderBy: 'order:number'"
  [name]="statusInfo[status.type] || ''"
  [color]="status.color"
  [isTruncateStatus]="false"
  (click)="changeStatus.emit(status)"
  class="ml-2 cursor-pointer">
</crm-status-label>
